import { createAction } from 'redux-act';

import { ICategoriesRequestParams, IServerFilterOption, IGiftTypesRequestParams } from './filters.types';

const PREFIX = 'MARKETPLACE/FILTERS';

export const loadGiftTypesRequest = createAction<IGiftTypesRequestParams>(`${PREFIX}/LOAD_GIFT_TYPES_REQUEST`);
export const loadGiftTypesSuccess = createAction<IServerFilterOption[]>(`${PREFIX}/LOAD_GIFT_TYPES_SUCCESS`);
export const loadGiftTypesFail = createAction<void>(`${PREFIX}/LOAD_GIFT_TYPES_FAIL`);

export const loadCategoriesRequest = createAction<ICategoriesRequestParams>(`${PREFIX}/LOAD_CATEGORIES_REQUEST`);
export const loadCategoriesSuccess = createAction<IServerFilterOption[]>(`${PREFIX}/LOAD_CATEGORIES_SUCCESS`);
export const loadCategoriesFail = createAction<void>(`${PREFIX}/LOAD_CATEGORIES_FAIL`);

export const loadBrandsRequest = createAction<ICategoriesRequestParams>(`${PREFIX}/LOAD_BRANDS_REQUEST`);
export const loadBrandsSuccess = createAction<IServerFilterOption[]>(`${PREFIX}/LOAD_BRANDS_SUCCESS`);
export const loadBrandsFail = createAction<void>(`${PREFIX}/LOAD_BRANDS_FAIL`);

export const resetFilters = createAction<void>(`${PREFIX}/RESET_FILTERS`);
